const ERROR_MESSAGE_MAP = {
  already_published_success_on_platform: '该平台已发布成功，无需重复发布',
  canceled_by_user: '已取消（用户中止）',
  missing_job_id: '缺少任务ID',
  job_not_found: '任务不存在',
  content_or_account_missing: '内容或账号缺失',
  missing_platform_code: '缺少平台信息',
  missing_content_id_or_account_id: '缺少内容或账号',
  platform_content_locked: '该平台内容正在发布中，请稍后再试',
  manager_unreachable: 'MCP 管理服务不可达',
  invalid_channel: '无效的渠道',
  missing_code: '缺少授权码',
  invalid_state: '无效的状态参数',
  state_mismatch: '状态校验失败',
  invalid_request: '请求参数无效',
  service_unavailable: '服务暂不可用',
  temporal_unavailable: 'Temporal 服务不可用',
  es_index_missing: 'ES 索引不存在，请先初始化索引',
  CANCELED: '已取消',
  UNSUPPORTED_PLATFORM: '不支持的平台',
  'Request body is not valid JSON.': '请求体不是合法的 JSON',
  "Missing Content-Type: application/json.": '缺少 Content-Type: application/json',
  "Missing or invalid 'body' field in request.": '请求体缺少或无效的 body 字段',
  "Missing or invalid 'content_id'.": '缺少或无效的 content_id',
  "Missing or invalid 'account_id'.": '缺少或无效的 account_id',
  "Missing or invalid 'publish_id'.": '缺少或无效的 publish_id',
  'Internal Server Error': '服务内部错误',
  'Not Found': '资源不存在',
  'Bad Request': '请求参数错误',
  Unauthorized: '未授权',
  Forbidden: '无权限访问',
  'Method Not Allowed': '请求方法不允许',
  'Service Unavailable': '服务暂不可用',
  'Gateway Timeout': '网关超时',
  'Request Timeout': '请求超时',
  'Too Many Requests': '请求过于频繁',
};

const ERROR_MESSAGE_PATTERNS = [
  {
    pattern: /^unsupported_platform:\s*(.+)$/i,
    format: (_msg, platform) => `不支持的平台：${platform}`,
  },
  {
    pattern: /^publish_not_found:\s*(.+)$/i,
    format: (_msg, detail) => `发布记录不存在：${detail}`,
  },
  {
    pattern: /^content_not_found:\s*(.+)$/i,
    format: (_msg, detail) => `内容不存在：${detail}`,
  },
  {
    pattern: /^account_not_found:\s*(.+)$/i,
    format: (_msg, detail) => `账号不存在：${detail}`,
  },
  {
    pattern: /^only_failed_publish_can_retry\s*\(status=(.+)\)$/i,
    format: (_msg, status) => `仅失败的发布记录可重试（当前状态：${status}）`,
  },
  {
    pattern: /^state_invalid:\s*(.+)$/i,
    format: (_msg, detail) => `状态校验失败：${detail}`,
  },
  {
    pattern: /^es_index_failed:\s*(.+)$/i,
    format: (_msg, detail) => `写入索引失败：${detail}`,
  },
  {
    pattern: /^HTTP\s+(\d+):\s*(.+)$/i,
    format: (_msg, code, reason) => `HTTP ${code}：${reason}`,
  },
  {
    pattern: /^workflow not found for id:\s*(.+)$/i,
    format: (_msg, id) => `工作流不存在或已结束：${id}`,
  },
];

const hasChinese = (value) => /[\u4e00-\u9fff]/.test(value);

export const formatErrorMessage = (raw) => {
  if (raw === null || raw === undefined) return '';
  const msg = String(raw).trim();
  if (!msg) return '';
  if (hasChinese(msg)) return msg;

  if (ERROR_MESSAGE_MAP[msg]) return ERROR_MESSAGE_MAP[msg];

  for (const { pattern, format } of ERROR_MESSAGE_PATTERNS) {
    const match = msg.match(pattern);
    if (match) {
      return format(msg, ...match.slice(1));
    }
  }

  if (/^[A-Z0-9_]+$/.test(msg) || /^[a-z0-9_]+$/.test(msg)) {
    return `操作失败（错误码：${msg}）`;
  }

  return `操作失败：${msg}`;
};

export const resolveErrorMessage = (raw, fallback = '') => {
  const formatted = formatErrorMessage(raw);
  return formatted || fallback || '';
};
